<template>
    <!-- FAQ 3 - Bootstrap Brain Component -->
    <section class="bsb-faq-3 py-3 py-md-5 py-xl-8">
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                    <h2 class="mb-4 display-5 text-center">Frequently Asked Questions</h2>
                    <p class="text-secondary text-center lead fs-4">Terimakasih Sudah Menyempatkan Untuk Membaca Disini.</p>
                    <p class="mb-5 text-center">Apa saja terkait permasalahan yang ada maupun terkait informasi kepegawaian yang sering ditanyakan atau bersifat umum di Pemerintah Kabupaten Kendal Kami Sampaikan disini.</p>
                    <hr class="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle">
                </div>
            </div>
        </div>

        <!-- FAQs: My Account -->
        <div class="mb-8">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-11 col-xl-10">
                        <div class="d-flex align-items-end mb-5">
                            <i class="bi bi-person-gear me-3 lh-1 display-5"></i>
                            <h3 class="m-0">Tentang Aplikasi</h3>
                        </div>
                    </div>
                    <div class="col-11 col-xl-10">
                        <div class="accordion accordion-flush" id="faqAccount">
                            <div class="accordion-item bg-transparent border-top border-bottom py-3">
                                <h2 class="accordion-header" id="faqAccountHeading1">
                                    <button
                                        class="accordion-button collapsed bg-transparent fw-bold shadow-none link-primary"
                                        type="button" data-bs-toggle="collapse" data-bs-target="#faqAccountCollapse1"
                                        aria-expanded="false" aria-controls="faqAccountCollapse1">
                                        Bagaimana cara reset Aplikasi Sabar?
                                    </button>
                                </h2>
                                <div id="faqAccountCollapse1" class="accordion-collapse collapse"
                                    aria-labelledby="faqAccountHeading1">
                                    <div class="accordion-body">
                                        <p>Seandainya Anda melakukan penggantian HP Android, dimohon untuk dapat datang ke pelayanan BKPP di kantor BKPP dengan membawa surat keterangan yang ditanda tangani Kepala Dinas.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item bg-transparent border-bottom py-3">
                                <h2 class="accordion-header" id="faqAccountHeading2">
                                    <button
                                        class="accordion-button collapsed bg-transparent fw-bold shadow-none link-primary"
                                        type="button" data-bs-toggle="collapse" data-bs-target="#faqAccountCollapse2"
                                        aria-expanded="false" aria-controls="faqAccountCollapse2">
                                        Bagaimana Jika Lupa Passwor SIASN?
                                    </button>
                                </h2>
                                <div id="faqAccountCollapse2" class="accordion-collapse collapse"
                                    aria-labelledby="faqAccountHeading2">
                                    <div class="accordion-body">
                                        <p>Jika mengalami lupa password SIASN, Anda bisa merubah password melalui failitas reset pada ASN DIGITAL dengan memasukkan NIP dan Email yang sudah terdaftar pada SIASN.</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

      
      
    </section>
</template>
<style>
.mb-6 {
    margin-bottom: 3.5rem !important
}

.mb-7 {
    margin-bottom: 4rem !important
}

.mb-8 {
    margin-bottom: 4.5rem !important
}

.mb-9 {
    margin-bottom: 5rem !important
}

.mb-10 {
    margin-bottom: 5.5rem !important
}

.mb-auto {
    margin-bottom: auto !important
}

.py-6 {
    padding-bottom: 3.5rem !important;
    padding-top: 3.5rem !important
}

.py-7 {
    padding-bottom: 4rem !important;
    padding-top: 4rem !important
}

.py-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
}

.py-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
}

.py-10 {
    padding-bottom: 5.5rem !important;
    padding-top: 5.5rem !important
}

@media(min-width:576px) {
    .mb-sm-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-sm-7 {
        margin-bottom: 4rem !important
    }

    .mb-sm-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-sm-9 {
        margin-bottom: 5rem !important
    }

    .mb-sm-10 {
        margin-bottom: 5.5rem !important
    }

    .mb-sm-auto {
        margin-bottom: auto !important
    }

    .py-sm-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-sm-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-sm-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-sm-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .py-sm-10 {
        padding-bottom: 5.5rem !important;
        padding-top: 5.5rem !important
    }
}

@media(min-width:768px) {
    .mb-md-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-md-7 {
        margin-bottom: 4rem !important
    }

    .mb-md-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-md-9 {
        margin-bottom: 5rem !important
    }

    .mb-md-10 {
        margin-bottom: 5.5rem !important
    }

    .mb-md-auto {
        margin-bottom: auto !important
    }

    .py-md-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-md-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-md-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-md-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .py-md-10 {
        padding-bottom: 5.5rem !important;
        padding-top: 5.5rem !important
    }
}

@media(min-width:992px) {
    .mb-lg-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-lg-7 {
        margin-bottom: 4rem !important
    }

    .mb-lg-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-lg-9 {
        margin-bottom: 5rem !important
    }

    .mb-lg-10 {
        margin-bottom: 5.5rem !important
    }

    .mb-lg-auto {
        margin-bottom: auto !important
    }

    .py-lg-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-lg-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-lg-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-lg-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .py-lg-10 {
        padding-bottom: 5.5rem !important;
        padding-top: 5.5rem !important
    }
}

@media(min-width:1200px) {
    .mb-xl-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-xl-7 {
        margin-bottom: 4rem !important
    }

    .mb-xl-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-xl-9 {
        margin-bottom: 5rem !important
    }

    .mb-xl-10 {
        margin-bottom: 5.5rem !important
    }

    .mb-xl-auto {
        margin-bottom: auto !important
    }

    .py-xl-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-xl-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-xl-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-xl-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .py-xl-10 {
        padding-bottom: 5.5rem !important;
        padding-top: 5.5rem !important
    }
}

@media(min-width:1400px) {
    .mb-xxl-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-xxl-7 {
        margin-bottom: 4rem !important
    }

    .mb-xxl-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-xxl-9 {
        margin-bottom: 5rem !important
    }

    .mb-xxl-10 {
        margin-bottom: 5.5rem !important
    }

    .mb-xxl-auto {
        margin-bottom: auto !important
    }

    .py-xxl-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-xxl-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-xxl-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-xxl-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .py-xxl-10 {
        padding-bottom: 5.5rem !important;
        padding-top: 5.5rem !important
    }
}

.bsb-btn-xl {
    --bs-btn-padding-y: 0.625rem;
    --bs-btn-padding-x: 1.25rem;
    --bs-btn-font-size: calc(1.26rem + 0.12vw);
    --bs-btn-border-radius: var(--bs-border-radius-lg)
}

@media(min-width:1200px) {
    .bsb-btn-xl {
        --bs-btn-font-size: 1.35rem
    }
}

.bsb-btn-2xl {
    --bs-btn-padding-y: 0.75rem;
    --bs-btn-padding-x: 1.5rem;
    --bs-btn-font-size: calc(1.27rem + 0.24vw);
    --bs-btn-border-radius: var(--bs-border-radius-lg)
}

@media(min-width:1200px) {
    .bsb-btn-2xl {
        --bs-btn-font-size: 1.45rem
    }
}

.bsb-btn-3xl {
    --bs-btn-padding-y: 0.875rem;
    --bs-btn-padding-x: 1.75rem;
    --bs-btn-font-size: calc(1.28rem + 0.36vw);
    --bs-btn-border-radius: var(--bs-border-radius-lg)
}

@media(min-width:1200px) {
    .bsb-btn-3xl {
        --bs-btn-font-size: 1.55rem
    }
}

.bsb-btn-4xl {
    --bs-btn-padding-y: 1rem;
    --bs-btn-padding-x: 2rem;
    --bs-btn-font-size: calc(1.29rem + 0.48vw);
    --bs-btn-border-radius: var(--bs-border-radius-lg)
}

@media(min-width:1200px) {
    .bsb-btn-4xl {
        --bs-btn-font-size: 1.65rem
    }
}

.bsb-btn-5xl {
    --bs-btn-padding-y: 1.125rem;
    --bs-btn-padding-x: 2.25rem;
    --bs-btn-font-size: calc(1.3rem + 0.6vw);
    --bs-btn-border-radius: var(--bs-border-radius-lg)
}

@media(min-width:1200px) {
    .bsb-btn-5xl {
        --bs-btn-font-size: 1.75rem
    }
}

.bsb-faq-3 .accordion {
    --bs-accordion-btn-icon: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27%23212529%27 class=%27bi bi-plus%27%3E%3Cpath d=%27M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z%27/%3E%3C/svg%3E");
    --bs-accordion-btn-active-icon: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27%23052c65%27 class=%27bi bi-dash%27%3E%3Cpath d=%27M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z%27/%3E%3C/svg%3E")
}
</style>